import React from 'react'
import { Icon, Button } from '../../../atoms'
import {
  EmptyStateContainer,
  EmptyIcon,
  EmptyTitle,
  EmptyText,
} from './NotesEmptyState.styles'
import type { NotesEmptyStateProps } from './NotesEmptyState.types'

export const NotesEmptyState: React.FC<NotesEmptyStateProps> = ({
  title = 'No notes yet',
  description = 'Start adding notes to keep track of important information',
  iconName = 'edit',
  action,
}) => {
  return (
    <EmptyStateContainer>
      <EmptyIcon>
        <Icon name={iconName as any} size="large" color="#999" />
      </EmptyIcon>
      <EmptyTitle>{title}</EmptyTitle>
      <EmptyText>{description}</EmptyText>
      {action && (
        <Button variant="primary" size="small" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </EmptyStateContainer>
  )
}

export const NotesNoResults: React.FC<NotesEmptyStateProps> = ({
  title = 'No results found',
  description = 'Try adjusting your search terms',
  iconName = 'search',
  action,
}) => {
  return (
    <NotesEmptyState
      title={title}
      description={description}
      iconName={iconName}
      action={action}
    />
  )
}
